import React from 'react';

class NoMatch extends React.Component {
  render() {
    return (
      <div>
        <h2>404 not found.</h2>
      </div>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.jsx